import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommunicationService} from '../services/communication.service';
import {ApplicationResponseData} from '../domains/common.domain';

@Injectable()

export class DocumentsService {
  constructor(private communicationService: CommunicationService) {
  }

  getData(params): Observable<ApplicationResponseData> {
    return this.communicationService.getData(`technician_application?technician_id=${params.technician_id}`);
  }
}
